import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { I } from './Icons'

const Head = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 28px;
  margin-bottom: 24px;
  align-items: flex-end;
`

const Eyebrow = styled.div`
  font-family: ${p => p.theme.fontFamily.sans.join(', ')};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${p => p.theme.colors.semantic.textMuted};
  margin-bottom: 6px;
`

const Title = styled.h1`
  font-family: ${p => p.theme.fontFamily.sans.join(', ')};
  font-size: 28px;
  letter-spacing: -0.02em;
  font-weight: 700;
  margin: 0 0 8px;
  line-height: 1.1;
  color: ${p => p.theme.colors.semantic.textPrimary};
`

const Meta = styled.div`
  display: flex;
  gap: 18px;
  color: ${p => p.theme.colors.semantic.textMuted};
  font-size: 13px;
  flex-wrap: wrap;
  span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  svg {
    width: 13px;
    height: 13px;
    opacity: 0.6;
  }
`

const StatusCol = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
`

const StatusPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 26px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: ${p =>
    p.$draft ? p.theme.colors.semantic.surfaceMuted : p.theme.colors.semantic.lilacTint};
  color: ${p => (p.$draft ? p.theme.colors.semantic.textMuted : p.theme.colors.semantic.accent)};
  span.dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${p =>
      p.$draft ? p.theme.colors.semantic.textMuted : p.theme.colors.semantic.accent};
  }
`

const WipAiReportHeader = ({ project, reportingPeriodLabel, isViewingPast }) => (
  <Head>
    <div>
      <Eyebrow>Work-in-Progress Report</Eyebrow>
      <Title>{project.name}</Title>
      <Meta>
        <span>
          <I.briefcase /> {project.client}
        </span>
        <span>
          <I.hash /> {project.matterNumber}
        </span>
        <span>
          <I.cal /> {reportingPeriodLabel}
        </span>
        <span>
          <I.dollar /> {project.CurrencyIsoCode}
        </span>
      </Meta>
    </div>
    <StatusCol>
      <StatusPill $draft={isViewingPast}>
        <span className="dot" />
        {isViewingPast ? 'Read-only · Past Rev' : 'Ready to export'}
      </StatusPill>
    </StatusCol>
  </Head>
)

WipAiReportHeader.propTypes = {
  project: PropTypes.object.isRequired,
  reportingPeriodLabel: PropTypes.string.isRequired,
  isViewingPast: PropTypes.bool.isRequired,
}

export default WipAiReportHeader
